import React from 'react';

// Design System Components
import SegmentedControl from 'Components/DesignSystem/SegmentedControl/SegmentedControl';

// Module Components
import SectionHeading from './SectionHeading';

// Constants
import { STRINGS, isImageFit } from '../../../constants';

// Types
import { ImageFit } from '../../../types';

interface ImageFitSectionProps {
  imageFit: ImageFit;
  onImageFitChange: (imageFit: ImageFit) => void;
}

const IMAGE_FIT_OPTIONS: { value: ImageFit; label: string }[] = [
  { value: 'fit', label: STRINGS.pane.imageFitFit },
  { value: 'fill', label: STRINGS.pane.imageFitFill },
  { value: 'stretch', label: STRINGS.pane.imageFitStretch },
];

/**
 * The Primary Image's Image display section: how the image fills the photo region
 * (spec R66 — the image's panel is Image display plus Custom styling, and nothing
 * else, because the image is the photo background rather than a block).
 *
 * Same segmented single-choice shape as Alignment and Description style (Q25).
 */
const ImageFitSection = ({ imageFit, onImageFitChange }: ImageFitSectionProps) => (
  <div className="tw-flex tw-flex-col tw-gap-2 tw-px-3 tw-py-3 tw-border-b tw-border-edge">
    <SectionHeading as="h4">{STRINGS.pane.imageFit}</SectionHeading>

    <SegmentedControl
      data-testid="product-card-image-fit"
      ariaLabel={STRINGS.pane.imageFit}
      options={IMAGE_FIT_OPTIONS.map((option) => ({ id: option.value, label: option.label }))}
      value={imageFit}
      onChange={(id) => {
        const value = String(id);
        if (isImageFit(value)) {
          onImageFitChange(value);
        }
      }}
    />
  </div>
);

export default ImageFitSection;
